module.exports = __webpack_public_path__ + "img/financial-health.f210f4ac.svg";